import React, { useEffect, useState } from 'react';
import VerificationPopup from '../modals/VerificationPopup';
import styles from '../../styles/newFeature.module.css';
import content from '../../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage, StackContainers, StackSkeleton } from '../qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from '../Industry/FAQ_mobile';
import FrequentQuestions from '../homePage/FrequentQuestions';
import MobilePDBanner from '../common/MobilePDBanner';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import TestimonialSection from '../common/TestimonialSection';
import MobileTestimonialSection from '../common/MobileTestimonialSection';
import ThreeStepForm from '../common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from '../common/OutletFeatures';
import { useRouter } from 'next/router';

const FlowerShop = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            image: "/assets/outlet/flowerShop/Image1.webp",
            tag: "Point Of Sale",
            icon: "/assets/groceries/kirana/POS.svg",
            title: "Billing for Loose Flowers & Bouquets",
            desc: "QueueBuster POS gives you a clean, organized billing module to cater to even the most flower shop-specific nuance. Selling a single stem or an ornately done-up bouquet can be billed in no time, and with the right price, customer transactions are managed with agility and precision. No more complex pricing headaches; QueueBuster POS will take care of it.",
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Easily set different prices for loose flowers, pre-arranged bouquets, and ordered ones over the counter.
                </>,
                <>
                    Our user-friendly interface makes selling quicker, ensuring that the customers keep walking in and out.                </>,
                <>
                    Supports multiple payment options: UPI, cash, credit, and digital.                </>,
            ],
        },
        {
            id: 2,
            image: "/assets/outlet/flowerShop/Image2.webp",
            tag: "Inventory Management",
            icon: "/assets/outlet/iceCreamOutlet/inventoryManagementIcon.svg",
            title: "Comprehensive Inventory and Stock Management",
            desc: "Managing a large variety and volume of floral inventory can be quite daunting. QueueBuster POS makes it very easy for you. With real-time stock levels at your fingertips, you will manage your perishable inventory effectively, ensuring you never run out of your best-selling lines. Best display assures that you always have the right products during the right days.",
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "10rem",
            eHeight: "26rem",
            msHeight: "15rem",
            meHeight: "41rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Keep track of your inventory levels and get alerts when stock is running low.
                </>,
                <>
                    Manage the lifecycle of perishable goods for minimal waste and maximum freshness.
                </>,
                <>
                    This seamlessly orders from suppliers directly through the system when stock is low.
                </>,
            ],
        },
        {
            id: 3,
            image: "/assets/outlet/flowerShop/Image3.webp",
            tag: "CRM & Loyalty Programs",
            icon: "/assets/outlet/flowerShop/CRMflower.svg",
            title: "Turn Walk-Ins Into Regulars With Our CRM & Loyalty Programs",
            desc: "Knowing and retaining your customers is the real key to success in floristry, and QueueBuster POS is outfitted with worthy CRM and loyalty tools. Whether it's regular customers, event planners, or corporate clients, our system enables you to foster long-term relationships that yield repeat business.",
            tagColor: "#EEC9FF",
            bgColor: "#fcf6ff",
            stackColor1: "#FCF7FF",
            stackColor2: "#F4E1FF",
            stackColor3: "#EEC9FF",
            stackColor4: "#E4ADFE",
            sHeight: "10rem",
            eHeight: "29rem",
            msHeight: "17rem",
            meHeight: "45rem",
            btnText: "Talk	to an expert",
            points: [
                <>
                    Segment your customer base and provide them with customized offerings.
                </>,
                <>
                    Run loyalty programs that give rewards to repeat customers and incentivize larger purchases.
                </>,
                <>
                    Store customer preferences, purchase history, and important dates, for personalized service                </>,
            ],
        },
        {
            id: 4,
            image: "/assets/outlet/flowerShop/image4.webp",
            tag: "Reports",
            icon: "/assets/outlet/flowerShop/reports.svg",
            title: "Automated Floral Reports & Insights",
            desc: "Stay on top of your business performance with QueueBuster POS's 80+ robust reports and analytics features. Our system provides insights that help you in making informed decisions, optimizing operations, and increasing profitability— all the while simplifying daily management tasks for you.",
            tagColor: "#4EEAC2",
            bgColor: "#e6fff9",
            stackColor1: "#C8F4E9",
            stackColor2: "#9EE9D6",
            stackColor3: "#4EEAC2",
            stackColor4: "#47DDB6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Get granular on sales performance, trends and customer behaviors.
                </>,
                <>
                    See your profit margins with your own eyes, while also realizing which products and services are actually bringing in the most profit for your business.
                </>,
                <>
                    Generate a variety of pre-configured or custom reports to answer all of your business needs, from seasonal sales to which products are selling at what volume.                </>,
            ],
        },
    ];

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    How will QueueBuster Florist POS Billing Software help me avoid stock wastage in my flower shop?
                </span>
            ),
            des:(
                <div>
                    <p>QueueBuster Florist POS Billing Software comes with high-end add-on inventory management features that help reduce stock wastage to a great extent. Real-time tracking of your inventory levels allows you to stay updated on stock levels and which items are soon to expire. The user can also set alerts on items when they need to be sold or put on a discount to save wastage.</p>
                    <p>The app also integrates with your suppliers, ensuring that re-orders can be automated when necessary. This way, you can stock just what you need and avoid over-orders or items sitting on shelves when they could be generating revenue. QueueBuster optimizes your stock levels and reduces your perishables to maintain a healthier inventory with less waste, boosting your bottom line.</p>
                </div>
            ),
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is different pricing possible on QueueBuster Florist POS for loose flowers, bouquets, and custom orders?
                </span>
            ),
            des: (
                <div>
                    <p>Yes, with QueueBuster Florist POS, you can have a huge degree of control over those varying price structures common in floral businesses. You will be able to set different prices for individual stems, pre-arranged bouquets, and even custom orders through this setup. By using this setup, you can basically create pricing tiers depending on the kind of flowers, arrangements, or even occasion-based, so every transaction is billed correctly.</p>
                    <p>Through tools for discounts and special offerings, which become much more manageable. For instance, one can offer bulk discounts on larger orders or seasonal promotions, and do so without the manual intervention required to make the settings. Not only does this feature make your billing process easy, but it also assures that with every piece of the product it remains consistent and competitive in the market.</p>
                </div>
            ),
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster Florist POS manage perishable inventory?
                </span>
            ),
            des: (
                <div>
                    <p>Florist queue busting POS has perishable inventory control as one of its key strengths. With the tools to manage stock shelf life, one can effectively focus on selling out goods that are closest to expiry. One can set automated reminders to alert staff to fast-selling products, reducing wastage.</p>
                    <p>QueueBuster also offers a platform for the user to make special promotions or discounts for stock close to the expiry date, hence expediting the sale of that stock. The very elaborate reporting in the system also gives insights as to which products are mostly prone to spoilage, hence adjusting the buying habits accordingly. This is a preventive measure towards unsold, spoiled flowers and therefore losing out on money in your inventory.</p>
                </div>
            ),
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What kind of information on customers is QueueBuster Florist POS capable of tracking, and how does this promote customer loyalty?
                </span>
            ),
            des: (
                <div>
                    <p>The QueueBuster Florist POS has a built-in and very detailed customer relationship management system. It captures customer contact details, sale transactions, preferences, special event days like birthday, or anniversary dates. This does allow the customer's service to be personalized, for example, sending reminders of events or tailoring promotions to the customer's taste.</p>
                    <p>This feature interacts through the loyalty program. Create loyalty programs that will reward a customer's purchasing behavior. For example, point-based systems that allow every customer to earn a point with every purchase to redeem against discounts or special offers in rewards. This feature increases customer satisfaction and encourages long-term loyalty through repeat business.</p>
                </div>
            ),
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How would QueueBuster Florist POS make my flower shop more effective in its daily functioning?
                </span>
            ),
            des: (
                <div>
                    <p>QueueBuster Florist POS is an essential tool for small and large businesses tailor-made to ensure that every single day is spent with ease. It makes billing, inventory management, and customer relations easier, which allows your staff to focus more on great customer service and not so much on administration.</p>
                    <p>For instance: billed fully and so automatically, it will result in clearance of sales quickly and in a precise manner, thus reducing waiting time at the counter. It keeps track of the level of stock on hand so you can maintain ideal levels of inventory without manual control of the same. A CRM system ensures your customer information is organized and at your fingertips; this, together with these efficiencies, results in smoother operation and saving you time and reducing human errors.</p>
                </div>
            ),
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I take it that the QueueBuster Florist POS is usable with every form of payment?
                </span>
            ),
            des: (
                <div>
                    <p>Absolutely. The QueueBuster Florist POS is designed for use with the widest possible variety of payment methods catering to the diverse needs for your customers. The software uses time-tested types of payment methods such as cash and credit cards, and today's modern technologies, such as mobile wallets, QR codes, contactless payments.</p>
                    <p>This flexibility makes sure that you can give your customers the methods of payment that they prefer, making their experience better and possibly boosting sales. Besides, the program facilitates the processing of payments fast, which reduces customer waits and minimizes time wastage as well as any errors that may affect the transactions.</p>
                </div>
            ),
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster Florist POS help with reporting and business analytics?
                </span>
            ),
            des: (
                <div>
                    <p>This is feature-rich reporting and analytics in QueueBuster Florist POS that goes real deep into your business performance. The software has over 80 different reports on all the key aspects of your operations, including the sales trend, customer behavior, inventory levels, and profitability. Generate any type of report on demand and customize it to any kind of metric you might want to keep an eye on.                    </p>
                    <p>The following insights enable you to make informed decisions on your pricing, inventory management, and marketing strategies. For instance, you can know your top-selling products, at what times the sales peak, and what your customers are looking for. This data-driven way you optimize your operations and maximize profitability.                    </p>
                </div>
            ),
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can QueueBuster Florist POS integrate with my existing e-commerce website?
                </span>
            ),
            des: (
                <div>
                    <p>Yes, QueueBuster Florist POS works easily with most ecommerce platforms, including the popular ones like Shopify. This one system accommodates both your online and in-store sales so you can easily view your business at any given time.</p>
                    <p>Orders placed from your website should synchronize in real-time with the POS system and, therefore, should make available for automatic updating inventory, payment processing for order fulfillment without necessarily needing to be input in the system manually. This saves time and reduces any possible errors while making sure that your inventory is updated across all sale channels.</p>
                </div>
            ),
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster Florist POS handle multiple store locations?
                </span>
            ),
            des: (
                <div>
                    <p>The POS for Florist by QueueBuster is a product meant to support multilocation operations seamlessly. The solution will help manage various flower shop chain locations from a single platform. All inventory, sales, and customer data will be handled on the basis of a centralized control system.</p>
                    <p>Each store may be operating by itself but still sharing information with one another, such as customer profiles or levels of inventory. This allows transfers of one's stock to other stores, easy coordination of promotions, and more. It also offers reporting on the basis of locations, inviting you to trace the performance of individual stores on individual grounds so that decisions could be backed by data to draw better optimization conclusions.</p>
                </div>
            ),
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What kind of customer support does QueueBuster Florist POS offer?
                </span>
            ),
            des: "QueueBuster Florist POS guarantees that you will have full customer support, letting you do your business with the least hiccups. We have a support team of seasoned, expert personnel in the floral business. They are always on hand to help you in case of any problems or questions. You can access the support line through phone, email, or live chat; different methods exist so you receive assistance in the most convenient way for you.",
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/outlet/flowerShop/mobilemainImge.webp')" }}>
                        <div>
                            <h1>
                                <span>Florist POS</span><span></span>
                                <span>&nbsp;Billing Software</span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>QB Flower Shop POS Billing Software has been created for speed and efficiency of sales process that automatically leads to consistent sales growth of your flower shop. this software with easy navigation and integration capabilities can prove to be a perfect tool to increase the bottom line of any floral business.</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 5rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/outlet/flowerShop/mainImage.webp"
                            heading={<>Florist POS</>}
                            staticHeading={<>Billing Software</>}
                            description={"QB Flower Shop POS Billing Software has been created for speed and efficiency of sales process that automatically leads to consistent sales growth of your flower shop. this software with easy navigation and integration capabilities can prove to be a perfect tool to increase the bottom line of any floral business."}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "55%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.features_section}>
                <div className={styles.section_heading}><h3>Best Features of Billing Software for Flower Shops</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <OutletFeatures features={features} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"FAQs for the QueueBuster Florist POS Billing Software"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"FAQs for the QueueBuster Florist POS Billing Software"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default FlowerShop